// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
  display: flex;
  align-items: center;
}

.dislay-flex {
  display: flex;
}

mat-option {
  background-color: none;
  font-size: 10pt;
  height: 15px;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/shared/person-search/person-search.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,sBAAA;EACA,eAAA;EACA,YAAA;AACJ","sourcesContent":[".form-group {\n    display: flex;\n    align-items: center;\n}\n\n.dislay-flex {\n    display: flex\n}\n\nmat-option {\n    background-color: none;\n    font-size: 10pt;\n    height:15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
